
const mutations = {
  setListSecurityQuestions: (state, payload) => {
    state.listSecurityQuestions = payload
  },
  setCurrentSecurityQuestion: (state, payload) => {
    state.currentSecurityQuestion = payload
  },
  setNotificationSettings: (state, payload) => {
    state.notificationSettings = payload
  }
}
export default mutations
